var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import styled from "styled-components";
import { Menu } from "grommet";
export var CustomMenu = styled(Menu)(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      "\n  color: #444444;\n  &:hover {\n    color: #e21a25;\n  }\n\n  button:hover {\n    a {\n      color: white;\n    }\n  }\n",
    ]))
);
export var MenuNavLink = styled.a(
  _templateObject2 ||
    (_templateObject2 = _taggedTemplateLiteralLoose([
      "\n  text-decoration: none;\n  font-size: 14px;\n  color: inherit;\n",
    ]))
);
export var HoverMenuNavLink = styled(MenuNavLink)(
  _templateObject3 ||
    (_templateObject3 = _taggedTemplateLiteralLoose([
      "\n  color: #444444;\n\n  &:hover {\n    color: #e21a25;\n  }\n",
    ]))
);
export var ModalMenuSubItem = styled.a(
  _templateObject4 ||
    (_templateObject4 = _taggedTemplateLiteralLoose([
      "\n  padding: 8px 20px;\n  font-size: 16px;\n  color: #444444;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: none;\n    color: #e21a25;\n  }\n",
    ]))
);
export var CustomLink = styled.a(
  _templateObject5 ||
    (_templateObject5 = _taggedTemplateLiteralLoose([
      "\n  color: #444444;\n  padding: 12px;\n  font-size: 16px;\n  text-decoration: none;\n  font-weight: 700;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.33);\n  &:hover {\n    color: #e21a25;\n  }\n",
    ]))
);
